import { Component, OnChanges } from '@angular/core';
import { Input } from '@angular/core';
import {
  ApexChart,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexLegend,
  ApexPlotOptions,
  ApexDataLabels,
  ApexTooltip,
  NgApexchartsModule
} from 'ng-apexcharts';

@Component({
  selector: 'app-pie-chart',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './pie-chart.component.html',
  styleUrl: './pie-chart.component.css'
})
export class PieChartComponent implements OnChanges {
  @Input() series: ApexNonAxisChartSeries = [];

  @Input() labels: string[] = [];

  @Input() totalLabel = 'Total';

  @Input() totalValue = '0';

  @Input() colors: string[] = [];

  @Input() height = 220;

  // public series: ApexNonAxisChartSeries = [
  //   850,
  //   214,
  //   96,
  //   88
  // ];

  public chart: ApexChart = {
    type: 'donut',
    height: this.height,
    background: 'transparent'
  };

  // public labels = [
  //   '850 Purchase Order',
  //   '214 ASN',
  //   '810 Invoice',
  //   '997 Functional Ack'
  // ];

  // public colors = [
  //   '#465FFF',
  //   '#22C55E',
  //   '#EF4444',
  //   '#FBBF24'
  // ];

  public dataLabels: ApexDataLabels = {
    enabled: false
  };

  public tooltip: ApexTooltip = {
    theme: 'dark',
    fillSeriesColor: false,
    y: {
      formatter: (val: number) => `${val}`
    }
  };

  public legend: ApexLegend = {
    position: 'bottom',

    fontSize: '13px',

    labels: {
      colors: '#94A3B8'
    }
  };

  public plotOptions: ApexPlotOptions = {
    pie: {
      donut: {
        size: '72%',

        labels: {
          show: true,

          name: {
            show: false
          },

          value: {
            show: false
          },

          total: {
            show: true,
            label: this.totalLabel,

            formatter: () => this.totalValue
          }
        }
      }
    }
  };

  public responsive: ApexResponsive[] = [
    {
      breakpoint: 768,
      options: {
        chart: {
          height: Math.max(240, this.height + 40)
        }
      }
    }
  ];

  ngOnChanges() {
    this.chart = {
      ...this.chart,
      height: this.height
    };
    this.plotOptions = {
      pie: {
        donut: {
          size: '72%',
          labels: {
            show: true,

            name: {
              show: false
            },

            value: {
              show: false
            },

            total: {
              show: true,
              label: this.totalLabel,

              formatter: () => this.totalValue
            }
          }
        }
      }
    };
  }
}